"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeEnvironment = void 0;
exports.isIkeEnvironment = isIkeEnvironment;
exports.IkeEnvironment = {
    /**
     * Local development environment
     * No cloud resources should reference this environment
     */
    LOCAL: 'local',
    /** Dev is the cloud environment intended to be linked to your local environment */
    DEV: 'dev',
    TEST: 'test',
    TEST2: 'test2',
    AUTOMATION: 'automation',
    STAGING: 'staging',
    PRODUCTION: 'production'
};
function isIkeEnvironment(value) {
    return Object.values(exports.IkeEnvironment).map(function (env) { return env.toString(); }).includes(value);
}
//# sourceMappingURL=environment.js.map